import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=beaf4806&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=js&"
export * from "./Avatar.vue?vue&type=script&lang=js&"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=beaf4806&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf4806",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Avatar.vue
// module id = null
// module chunks = 